module.exports = __webpack_public_path__ + "images/backgrounds/ocean/small.e6dcb18166ac690492f6.jpg";